// Shared date formatting — every date shown anywhere in the app renders as
// DD/MM/YYYY (and DD/MM/YYYY HH:MM for timestamps), independent of the
// visitor's browser/OS locale. The old approach (calling the browser's own
// `.toLocaleDateString()`/`.toLocaleString()` directly, scattered across the
// codebase) rendered MM/DD/YYYY on any US-locale device and other formats
// elsewhere — inconsistent across different users viewing the same data.
export function formatDate(input) {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function formatDateTime(input) {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "—";
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(d)} ${hh}:${min}`;
}

// Oodel X insight periods are stored as EXCLUSIVE half-open ranges on the
// backend (e.g. a Mon-Sun week's `period_end` is the FOLLOWING Monday, so
// arithmetic/queries never double-count a boundary instant). Displaying
// that raw `period_end` reads as one day too long to a human ("Aug 17 -
// Aug 24" for a week that's actually Aug 17-23) — these two helpers convert
// to the INCLUSIVE calendar date a person actually expects to read.
export function inclusiveEndDate(exclusiveEnd) {
  if (!exclusiveEnd) return null;
  const e = exclusiveEnd instanceof Date ? new Date(exclusiveEnd) : new Date(exclusiveEnd);
  if (isNaN(e.getTime())) return null;
  e.setUTCDate(e.getUTCDate() - 1);
  return e;
}

export function formatRangeInclusive(start, exclusiveEnd) {
  const e = inclusiveEndDate(exclusiveEnd);
  if (!start || !e) return "—";
  return `${formatDate(start)} – ${formatDate(e)}`;
}
